<template>
  <div class="header-menu" :class="isAdvert ? 'header-menu-top' : ''">
    <div class='header'>
      <div class="top-advert" v-if="isAdvert">
        <div @click="handleAdvert">
          <img class="advert-img" :src="topAdvertData.image" alt="">
        </div>
        <img @click="closeAdvert" class="advert-img-x" src="../assets/img/advert-close.png" alt="" />
      </div>
      <div class="header-main">
        <div class='header-logo'>
          <router-link :to="{ path: '/' }">
            <div>
              <img :src="this.getSettingConfig.getInfo('site_logo')" alt="">
            </div>
          </router-link>
        </div>
        <el-row type='flex' justify='center' align='middle'>
          <el-col :span="15">
            <div class='header-tab'>
              <el-menu :default-active="this.$route.meta.activeMenu ? this.$route.meta.activeMenu : this.$route.path"
                class="el-menu-demo lg-menu" mode="horizontal" router background-color="transparent"
                text-color="#909399" active-text-color="#ffde00">
                <el-menu-item :index="item.route" v-for="item in tab_list" :key="item.route">{{
                    item.name
                }}
                </el-menu-item>
              </el-menu>
            </div>
          </el-col>
          <el-col :span="3">
            <div class='search-text'>
              <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchText"
                @keyup.enter.native="handleSearchInfo" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class='reg-text'>
              <div class="reg-text-vip">
                <router-link :to="{ path: '/vip' }">
                  <img v-if="!loginStatus" class="icon-vip" src="../assets/img/index/icon-vip.png" alt="">
                </router-link>
              </div>
              <el-badge :hidden="this.$store.state.status.message_count === 0" v-if="!loginStatus"
                :value='this.$store.state.status.message_count' class="item">
                <router-link :to="{ path: '/message', query: { category: 'push' } }"><img
                    src="../assets/img/index/info.png" alt=""></router-link>
              </el-badge>
              <div class='reg-btn' v-if="loginStatus">
                <button @click="handleLogin('login')">登录</button>
                <button @click="handleLogin('reg')">注册</button>
              </div>
              <div v-else class='user-avatar'>
                <div class="avatar" @mouseover="MenuShow = true" @mouseleave="MenuShow = false">
                  <el-avatar :src="avatar_url"></el-avatar>
                  <img v-if="user_info.is_member" class="user-vip" :src="getSettingConfig.getInfo('vip_icon')" alt="">
                </div>
                <div class="right-menu" :style="{ 'margin-top': isAdvert ? '60PX' : '' }" v-show="MenuShow"
                  @mouseover="MenuShow = true" @mouseleave="MenuShow = false">
                  <ul>
                    <router-link :to="{ path: '/personal', query: { name: 'basic' } }">
                      <li>
                        <img class="personal" src="../assets/img/index/personal.png" alt=""><span>个人中心</span>
                      </li>
                    </router-link>
                    <router-link :to="{ path: '/vip' }">
                      <li>
                        <img class="personal" src="../assets/img/index/vip.png" alt=""><span>会员中心</span>
                      </li>
                    </router-link>
                    <router-link :to="{ path: '/account/setting', query: { id: '0' } }">
                      <li>
                        <img class="personal" src="../assets/img/index/icon-level.png" alt=""><span>我的等级</span>
                      </li>
                    </router-link>
                    <router-link :to="{ path: '/account/setting', query: { id: '1' } }">
                      <li>
                        <img class="password" src="../assets/img/index/password.png" alt=""><span>账号密码</span>
                      </li>
                    </router-link>
                    <router-link :to="{ path: '/account/setting', query: { id: '2' } }">
                      <li>
                        <img class="password" src="../assets/img/index/icon-account.png" alt=""><span>账号关联</span>
                      </li>
                    </router-link>
                    <router-link :to="{ path: '/account/setting', query: { id: '3' } }">
                      <li>
                        <img class="message" src="../assets/img/index/message.png" alt=""><span>消息设置</span>
                      </li>
                    </router-link>
                    <li @click="handleChangeType">
                      <img class="switch" src="../assets/img/index/switch.png" alt=""><span>切换为企业</span>
                    </li>
                    <li @click="handleLoginOut">
                      <img class="out" src="../assets/img/index/out.png" alt=""><span>退出登录</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_info: JSON.parse(localStorage.getItem("user-info")),
      avatar_url: null,
      searchText: '',
      tab_list: [
        { name: '首页', route: '/' },
        { name: '教学课程', route: '/course' },
        { name: '任务大厅', route: '/task' },
        { name: '诸葛问计', route: '/answer' },
        { name: '诸葛严选', route: '/partner' },
        // {name:'诸葛榜',route: '/recommend/designer'},
        { name: '发现', route: '/found' }
      ],
      loginStatus: true,
      MenuShow: false,
      topAdvertData: '',
      isAdvert: false
    }
  },
  created() {
    // 顶部广告
    this.$requestApi.api.top_advert({ type: 'client', tag: 'top_advert' }).then(res => {
      this.topAdvertData = res.data
      if (!sessionStorage.getItem('client_isAdvert')) {
        if (this.topAdvertData) {
          this.$requestApi.video.advert_detail(this.topAdvertData.id, { flag: 'view' }).then()
          this.isAdvert = true
        } else {
          this.isAdvert = false
        }
      }
    })
    // 更新信息
    this.$Bus.$off('uploadInfo').$on('uploadInfo', () => {
      this.loginStatus = false
      this.$requestApi.api.userInfo().then(res => {
        this.user_info = res.data
        this.avatar_url = res.data.avatar_info
        this.$forceUpdate()
      })
    })
    // 搜索
    this.$Bus.$off('search').$on('search', value => this.searchText = '')
    // 更新头像
    this.$Bus.$off("upload_avatar").$on("upload_avatar", value => {
      this.user_info = value
      this.avatar_url = value.avatar_info
      this.$forceUpdate()
    })
    this.$nextTick(() => {
      const token = localStorage.getItem('Authorization')
      token ? this.loginStatus = false : this.loginStatus = true
    })
  },
  methods: {
    // 登录
    handleLogin(data) {
      this.$store.state.status.login = true
      data === 'reg' ? this.$store.state.status.loginStatus = false : this.$store.state.status.loginStatus = true
    },
    // 登出
    handleLoginOut() {
      this.$requestApi.api.loginOut()
        .then(res => {
          localStorage.removeItem('Authorization')
          localStorage.removeItem("user-info")
          this.$router.push('/')
          this.loginStatus = true
          this.MenuShow = false
          location.reload();
        })
    },
    // 搜索
    handleSearchInfo() {
      if (this.searchText.trim() === '') return
      this.$route.name === 'search_detail' ? this.$Bus.$emit('searchText', this.searchText.trim()) : this.$router.push({
        name: 'search_detail',
        query: { keywords: this.searchText.trim() }
      })
    },
    // 切换为企业
    handleChangeType() {
      window.location.href = this.getSettingConfig.getInfo('app_url') + '/enterprise/'
    },
    //广告点击
    handleAdvert() {
      this.$requestApi.video.advert_detail(this.topAdvertData.id, { flag: 'click_num' }).then()
      window.open(this.topAdvertData.link);
    },
    // 关闭广告
    closeAdvert() {
      sessionStorage.setItem("client_isAdvert", '1')
      this.isAdvert = false
    }
  }
}
</script>
<style lang='less'>
.el-row {
  width: 100%;
}

.header-tab {
  .lg-menu {
    height: 48px;
    border-bottom: 0 !important;

    .el-menu-item {
      line-height: 48px;
      height: 48px;
      background-color: transparent !important;
      font-size: 15px;
    }

    .el-menu-item:not(:last-child) {
      margin-right: 55px;
    }

    .el-menu-item.is-active {
      background-color: #ffde00 !important;
      color: #333333 !important;
      border: 0 !important;
    }

    .el-menu-item.is-active:hover {
      color: #333333 !important;
    }

    .el-menu-item:hover {
      color: #ffde00 !important;
    }
  }
}

.search-text {
  .el-input {
    height: 25px;
  }

  .el-input__inner {
    height: 25px;
    line-height: 25px;
    border-radius: 50px;
  }

  .el-input__icon {
    line-height: 25px;
  }
}

.user-avatar {
  .el-avatar {
    width: 34px;
    height: 34px;
    line-height: 50px;
  }
}
</style>

<style scoped lang='less'>
.header-menu-top {
  padding-bottom: 60px;
}

@media screen and (max-width:1920px) {
  .header-menu-top {
  padding-bottom: 60PX;
}
}

.header-menu {

  /*z-index: 9999;*/
  .user-vip {
    width: 12px !important;
    height: 12px !important;
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  .header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 48px;
    z-index: 9999;
    cursor: pointer;

    .top-advert {
      height: 60px;
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;

      .advert-img {
        width: 100%;
        height: 60px;
        object-fit: fill
      }

      .advert-img-x {
        position: absolute;
        min-width: 32px;
        min-height: 32px;
        right: 234px;
      }
    }

    @media screen and (max-width:1920px) {
      .top-advert {
        height: 60PX;
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;

        .advert-img {
          width: 100%;
          height: 60PX;
          object-fit: fill
        }

        .advert-img-x {
          position: absolute;
          min-width: 32PX;
          min-height: 32PX;
          right: 234px;
        }
      }
    }

    .header-main {
      display: flex;
      align-items: center;
      background-color: #1D1D1D;

    }

    .header-logo {
      div {
        width: 150px;
        height: 37px;
        margin: 0 165px 0 100px;
      }

      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .reg-text {
      margin-left: 55px;
      display: flex;
      align-items: center;

      .reg-text-vip {
        margin-right: 20px;
      }

      .reg-type {
        color: #ffffff;
        position: relative;

        div {
          position: absolute;
          top: 34px;
          left: -50px;
          background-color: #ffffff;
          padding: 18px 0 0;
          min-width: 170px;
          box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.1);
          border-radius: 0 0 4px 4px;
          display: none;
          text-align: center;

          p {
            white-space: nowrap;
            margin: 0 18px 18px;

            img {
              width: 18px;
              height: 18px;
              display: inline-block;
              margin-right: 11px;
              vertical-align: middle;
              position: relative;
              bottom: 2px;
            }

            span {
              white-space: nowrap;
              color: #333333;
              font-size: 14px;
            }
          }
        }
      }

      .reg-type:hover {
        color: #ffde00;

        div {
          display: block
        }
      }

      img {
        width: 20px;
        height: 26px;
      }

      .icon-vip {
        width: auto;
        height: 24px;
      }

      /deep/ .el-badge__content {
        width: 18px;
        min-height: 18px;
        text-align: center;
        line-height: 17px;
        font-size: 12px;
        border-color: #ff3b30;
        background-color: #ff3b30;
        padding: 0 1px 0 0;
      }

      .reg-btn {
        margin-left: 20px;
        background-color: #FFDE00;
        display: flex;
        align-items: center;
        border-radius: 4px;
        padding: 0 10px;
        min-width: 108px;
        height: 28px;

        button {
          background-color: #FFDE00;
          border-radius: 4px;
          font-size: 14px;
          color: #000000;
        }

        button:first-child:after {
          content: '|';
          font-size: 14px;
          margin: 0 20px;
          color: #000000;
        }
      }

      .user-avatar {
        margin-left: 31px;
        position: relative;

        .avatar {
          height: 48px;
          position: relative;
          display: flex;
          align-items: center;
        }

        .right-menu {
          background-color: #F4F4F4;
          box-shadow: 1px 3px 7px 0 rgba(0, 0, 0, 0.1);
          border-radius: 0 0 4px 4px;
          position: fixed;
          right: 120px;
          top: 48px;

          ul {
            li {
              padding: 0 54px 0 12px;
              background-color: #FFFFFF;
              line-height: 46px;

              img {
                width: 16px;
                height: 20px;
                display: inline-block;
                margin: 0 14px 0 12px;
                vertical-align: middle;
              }

              span {
                color: #666666;
                font-size: 14px;
              }
            }

            li:hover {
              background-color: #ebeef5;
              cursor: pointer;
            }

            li:not(:last-child) {
              margin-bottom: 4px;
            }

            li:last-child {
              border-radius: 0 0 4px 4px;
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/header.vue